import { z } from "zod";

export const schemas = {
  ParticipantId: z.object({
    id: z.string().min(1),
    deviceFingerprint: z.string().min(1),
    timestamp: z.number().int().positive(),
    version: z.literal("1.0.0"),
  }),

  FingerprintComponents: z.object({
    canvas: z.string(),
    webgl: z.string(),
    screen: z.string(),
    fonts: z.string(),
    audio: z.string(),
    userAgent: z.string(),
    timezone: z.string(),
    language: z.string(),
    platform: z.string(),
  }),
} as const;

export type SchemaTypes = {
  ParticipantId: z.infer<typeof schemas.ParticipantId>;
  FingerprintComponents: z.infer<typeof schemas.FingerprintComponents>;
};
